import { BIIconButton } from '@pulsepointinc/bi-components';
import { useRef, useState } from 'react';
import { useSendAIChatMessageMutation, useStartAIChatMutation } from '../../../../hooks/api';
import { useCurrentWorkspace } from '../../../../hooks/useCurrentWorkspace';
import { useAIContext } from '../../AIProvider';
import { AIPromptTextArea } from './AIPromptTextArea';
import { StyledPromptContainer } from './styles';

export const AIPrompt: React.FC = () => {
  const promptTextarea = useRef<HTMLTextAreaElement | null>(null);
  const { currentWorkspace } = useCurrentWorkspace();
  const { activeChatId, setActiveChatId } = useAIContext();
  const { mutateAsync: startAIChat } = useStartAIChatMutation();
  const { mutate: sendAIChatMessage } = useSendAIChatMessageMutation();

  const [prompt, setPrompt] = useState('');

  const getIsPromptEmpty = (value?: string) => {
    return !(value ?? prompt).replace(/[\s\n]/g, '').trim();
  };

  const changePrompt = (value: string) => {
    if (!prompt && getIsPromptEmpty(value)) {
      return;
    }

    setPrompt(value);
  };

  const submitPrompt = async () => {
    if (getIsPromptEmpty() || !currentWorkspace?.workspace_id) {
      return;
    }

    setPrompt('');

    try {
      if (activeChatId) {
        sendAIChatMessage({
          workspaceId: 5196,
          chatId: activeChatId,
          message: prompt,
          max_prompt_tokens: 1000,
          unsummarized_token_threshold: 1000,
        });

        return;
      }

      const { chat_id } = await startAIChat({
        workspaceId: 5196,
        chat_title: 'New AI Chat testing',
        system_prompt: prompt,
      });

      setActiveChatId(chat_id);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <StyledPromptContainer>
      <AIPromptTextArea
        ref={promptTextarea}
        placeholder="Enter a prompt"
        value={prompt}
        onChange={(e) => changePrompt(e.target.value)}
        onKeyDown={(e) => {
          if (!getIsPromptEmpty() && e.key === 'Enter') submitPrompt();
        }}
      />
      <BIIconButton
        type="submit"
        variant="primary"
        icon="AngleRight"
        style={{ marginLeft: 'auto' }}
        onClick={submitPrompt}
      />
    </StyledPromptContainer>
  );
};
